import type { AnimationNodeKind } from "@/document/model/animation";

export function animationNodeKindForHotkey(event: KeyboardEvent): AnimationNodeKind | undefined {
  if (event.metaKey || event.ctrlKey || event.altKey) {
    return undefined;
  }
  switch (event.key.toLowerCase()) {
    case "a":
      return "animation";
    case "g":
      return "group";
    case "b":
      return "animate";
    case "m":
      return "motion";
    default:
      return undefined;
  }
}
